export default {
  USERS: {
    CURRENT_USER_TOKEN: 'users/current_user_token',
    CURRENT_USER_ID: 'users/current_user_id',
    CURRENT_USER_CLAIMS: 'users/current_user_claims',
    USER_IS_LOGGED: '@onboard/user/userIsLogged',
    SCHOOL_IS_LOGGED: false,
  },
  DRAWER: {
    TOTAL_SCROLL: '@onboard/drawerTotalScroll',
    ITEM_OPEN: '@onboard/collapseItemOpen',
    CURRENT_PATH: '@onboard/drawerCurrentPath',
  },
  ITINERARY: {
    ITINERARY_DEPARTURE_TIME: '@onboard/itineraryDepartureTime',
    ITINERARY_ARRIVAL_TIME: '@onboard/itineraryArrivalTime',
    ITINERARY_NAME: '@onboard/itineraryName',
    ITINERARY_DAYS: '@onboard/itineraryDays',
    SELECTED_PATH_WAY: '@onboard/selectedPathWay',
    SELECTED_PATH_TITLE: '@onboard/selectedPathTitle',
    LINE_ID: '@onboard/itineraryLineId',
    PATH_ID: '@onboard/itineraryPathId',
  },
  PASSENGERS: {
    FILTER_BY_NAME: '@onboard/filterByServer/name/isChecked',
    FILTER_BY_EMAIL: '@onboard/filterByServer/email/isChecked',
    FILTER_BY_PHONE: '@onboard/filterByServer/phone',
  },
  TRANSPORT_VOUCHERS: {
    HIDDEN_ITEMS: '@onboard/TransportVouchers/hiddenItems',
  },
  FILTERS: {
    CURRENT_SEARCH_TERM: '@onboard/current_search_term',
    CURRENT_ADVANCED_SEARCH_TERM: '@onboard/current_advanced_search_term',
    CURRENT_ADVANCED_SEARCH_OBJECT: '@onboard/current_advanced_search_object',
  },
  TRIP: {
    CURRENT_TRIP_ID: '@onboard/current_trip_id',
  },
  SYSTEM_CONFIG: {
    TEST_ONLY: 'testOnly',
  },
  TICKET_SALES: {
    STAR_STOP: 'ticketSales/startStop',
    END_STOP: 'ticketSales/endStop',
    CURRENT_USER_TOKEN: 'ticketSales/current_user_token',
    CURRENT_USER_CLAIMS: 'ticketSales/current_user_claims',
    CURRENT_LINE_LIST: 'ticketSales/current_line_list',
    LAST_PATH: 'ticketSales/lastPath',
  },
  WEB_USER: {
    DATA: 'web_user/data',
  },
};
